import React from "react";
import SearchableCombobox from "@/components/SearchableCombobox";

/**
 * Searchable picker for an item's existing stock batches — used by Stock
 * Adjustment so users can only ever adjust a real, currently-available
 * batch (fixes "Batch not found" errors from free-typed batch numbers).
 */
export default function BatchCombobox({
  batches = [],
  value = "",
  onPick,
  testId = "batch-combobox",
  placeholder = "Select batch…",
  className = "",
  disabled = false,
}) {
  return (
    <SearchableCombobox
      options={batches}
      value={value}
      onPick={onPick}
      testId={testId}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      emptyLabel="No batches found for this item."
      getId={(b) => b.batch_no}
      getKey={(b) => b.batch_no}
      getLabel={(b) => b.batch_no || "—"}
      getSecondary={(b) => {
        const qty = `${Number(b.qty || 0).toLocaleString("en-IN")} ${b.uom || ""}`.trim();
        const exp = b.expiry_date ? ` · exp ${b.expiry_date}` : "";
        return `${qty} avail${exp}`;
      }}
      getSearchFields={(b) => [b.batch_no, b.lot_no]}
    />
  );
}
